<template>
  <b-button-group class="mx-1 mb-1 mb-md-0" :size="toolbarButtonSize">
    <b-dropdown :text="defaultLabel" :variant="defaultVariant" :disabled="disabled" :size="toolbarButtonSize">
      <b-dropdown-item :variant="saveVariant" v-on:click="save()" :disabled="disabled">{{ saveLabel }}</b-dropdown-item>
      <b-dropdown-item :variant="clearVariant" v-on:click="clear()" :disabled="disabled">{{ clearLabel }}</b-dropdown-item>
    </b-dropdown>
    <b-dropdown :text="setText" variant="info" v-if="filterSetsVisible" :size="toolbarButtonSize">
      <b-dropdown-form v-if="filterSets && filterSets.length">
        <b-form-group label="Current Set">
          <select class="form-control-sm" v-model="selectedFilterSetName" :disabled="disabled" @change="selectFilterSet()">
            <option value="">[New]</option>
            <option v-for="filterSet in filterSets" :key="filterSet.name" :value="filterSet.name">{{ filterSet.name }}</option>
          </select>
        </b-form-group>
        <b-btn :variant="removeFilterSetVariant" size="sm" v-on:click="removeFilterSet()" :disabled="disabled">{{ removeFilterSetLabel }}</b-btn>
        <b-btn :variant="sortFilterSetVariant" size="sm" v-on:click="sortFilterSets()" :disabled="disabled">{{ sortFilterSetLabel }}</b-btn>
      </b-dropdown-form>
      <b-dropdown-form>
        <b-form-group label="New Set Name">
          <input type="text" class="form-control-sm" v-model="editFilterSetName" :disabled="disabled" />
        </b-form-group>
        <b-btn :variant="saveFilterSetVariant" size="sm" v-on:click="saveFilterSet()" :disabled="disabled">{{ saveFilterSetLabel }}</b-btn>
      </b-dropdown-form>
    </b-dropdown>
    <b-button :variant="permaLinkVariant" tag="a" :href="permaLink" target="_blank" v-if="filterSetsVisible && permaLink">Perma-Link</b-button>
  </b-button-group>
</template>
<script>
  export default {
    name: "generic-default-parameters",
    props: {
      value: {
        type: Object,
        required: true
      },
      filterKey: {
        type: String,
        required: true
      },
      visible: {
        type: Boolean,
        default: true
      },
      filterSetsVisible: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      defaultLabel: {
        type: String,
        default: 'Default'
      },
      defaultVariant: {
        type: String,
        default: 'primary'
      },
      saveLabel: {
        type: String,
        default: 'Save'
      },
      saveVariant: {
        type: String,
        default: 'info'
      },
      clearLabel: {
        type: String,
        default: 'Clear'
      },
      clearVariant: {
        type: String,
        default: 'info'
      },
      saveFilterSetLabel: {
        type: String,
        default: 'Save'
      },
      saveFilterSetVariant: {
        type: String,
        default: 'primary'
      },
      permaLinkVariant: {
        type: String,
        default: 'success'
      },
      removeFilterSetLabel: {
        type: String,
        default: 'Delete'
      },
      removeFilterSetVariant: {
        type: String,
        default: 'danger'
      },
      sortFilterSetLabel: {
        type: String,
        default: 'Sort'
      },
      sortFilterSetVariant: {
        type: String,
        default: 'info'
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      clearMessage: {
        type: String,
        default: 'Your Default Search has been cleared'
      },
      saveMessage: {
        type: String,
        default: 'Your Default Search has been updated'
      },
      loadMessage: {
        type: String,
        default: 'Your Default Search has been executed'
      },
      sessionLoadMessage: {
        type: String,
        default: 'Your Most Recent Search has been executed'
      },
      permaLinkLoadMessage: {
        type: String,
        default: 'Your Perma Linked Filters have been executed'
      },
      permaLinkFailMessage: {
        type: String,
        default: 'Your Perma Linked Filters could not be decoded and were not executed'
      },
      countdownSeconds: {
        type: Number,
        default: 3
      },
      tableId: {
        type: Number,
        required: true
      },
      toolbarButtonSize: {
        type: String,
        default: 'md'
      }
    },
    created() {
      this.queryString = appHelpers.url.parseQueryString();
      this.init();
    },
    data() {
      return { 
        state: window.appState,
        currentFilters: this.value,
        parentMessages: this.messages,
        filterSets: [ ],
        selectedFilterSetName: '',
        editFilterSet: { },
        editFilterSetName: null,
        queryString: { },
        permaLink: null,
        defaultFilters: null,
      };
    },
    watch: {
      value: {
        handler: function(val) {
          this.currentFilters = val;
          if (this.defaultFilters === null || !Object.keys(this.defaultFilters).length) {
            this.defaultFilters = Object.assign({}, val);
          }
          this.calcPermaLink();
        },
        deep: true
      }
    },
    computed: {
      setText() {
        let text = 'Sets';
        if (this.filterSetsVisible && this.selectedFilterSetName) {
          text += ` [${this.selectedFilterSetName}]`;
        }
        return text;
      }
    },
    methods: {
      init() {
        let filterSetKey = `${this.filterKey}-${this.state.currentTenantId}-filter-sets`;
        let filterSetString = localStorage.getItem(filterSetKey);
        if (filterSetString) {
          this.filterSets = JSON.parse(filterSetString);
        }
        if (this.defaultFilters === null || !Object.keys(this.defaultFilters).length) {
          this.defaultFilters = Object.assign({}, this.value);
        }
        this.calcPermaLink();
      },
      cleared(filters, sortBy, sortDesc) {
        this.calcPermaLink();
      },
      selectFilterSet() {
        let existingFilterSet = this.filterSets.find((filterSet) => filterSet.name === this.selectedFilterSetName);
        let selectedFilterSet = { };
        if (existingFilterSet && existingFilterSet.name && existingFilterSet.data) {
          Object.assign(selectedFilterSet, existingFilterSet);
          this.editFilterSet = selectedFilterSet;
          this.editFilterSetName = selectedFilterSet.name;
          this.setFilter(selectedFilterSet.data);
        } else {
          this.clearFilterSet();
        }
      },
      saveFilterSet() {
        if (this.editFilterSetName) {
          let filterSetKey = `${this.filterKey}-${this.state.currentTenantId}-filter-sets`;
          let existingFilterSet = this.filterSets.find((filterSet) => filterSet.name === this.editFilterSet.name);
          let newFilterSet = null;
          let newFilters = { };
          Object.assign(newFilters, this.currentFilters);
          if (existingFilterSet) {
            existingFilterSet.name = this.editFilterSetName;
            existingFilterSet.data = newFilters;
          } else {
            newFilterSet = {
              name: this.editFilterSetName,
              data: newFilters
            };
            this.filterSets.push(newFilterSet);
          }
          let filterSetString = JSON.stringify(this.filterSets);
          localStorage.setItem(filterSetKey, filterSetString);
          this.clearFilterSet();
        }
      },
      sortFilterSets() {
        let filterSetKey = `${this.filterKey}-${this.state.currentTenantId}-filter-sets`;
        this.filterSets = this.filterSets.sort((a, b) => a.name === b.name ? 0 : (a.name < b.name ? -1 : 1));
        let filterSetString = JSON.stringify(this.filterSets);
        localStorage.setItem(filterSetKey, filterSetString);
      },
      removeFilterSet() {
        let filterSetKey = `${this.filterKey}-${this.state.currentTenantId}-filter-sets`;
        let existingFilterSetIndex = this.filterSets.findIndex((filterSet) => filterSet.name === this.selectedFilterSetName);
        if (existingFilterSetIndex >= 0) {
          this.filterSets.splice(existingFilterSetIndex, 1);
          let filterSetString = JSON.stringify(this.filterSets);
          localStorage.setItem(filterSetKey, filterSetString);
          this.clearFilterSet();
        }
      },
      clearFilterSet() {
        this.selectedFilterSetName = '';
        this.editFilterSet = { };
        this.editFilterSetName = null;
      },
      setFilter(newFilter) {
        let defaultFiltersSet = (this.defaultFilters !== null && !!Object.keys(this.defaultFilters).length);
        let defaultFilters = defaultFiltersSet ? this.defaultFilters : this.currentFilters;
        let filter = appHelpers.object.unstrip(newFilter, defaultFilters, defaultFiltersSet);
        this.$emit('input', filter);
        this.$emit('change', filter);
      },
      clear() {
        let filterKey = `${this.filterKey}-${this.state.currentTenantId}`;
        localStorage.removeItem(filterKey);
        sessionStorage.removeItem(filterKey);
        if (this.clearMessage && this.clearMessage.length) {
          this.$emit('alert', { text: this.clearMessage, variant: 'success', countdown: this.countdownSeconds}, true);
        }
      },
      save(tempFlag) {
        let filterKey = `${this.filterKey}-${this.state.currentTenantId}`;
        let filterString = JSON.stringify(this.currentFilters);
        if (!tempFlag)
        {
          localStorage.setItem(filterKey, filterString);
          if (this.saveMessage && this.saveMessage.length) {
            this.$emit('alert', { text: this.saveMessage, variant: 'success', countdown: this.countdownSeconds}, true);
          }
        }
        else
        {
          sessionStorage.setItem(filterKey, filterString);
        }
      },
      load(allowTempFlag) {
        let firstMessage = true;
        let sessionFlag = false;
        let filterString = null;
        let filterKey = `${this.filterKey}-${this.state.currentTenantId}`;
        if (this.queryString.filterSet) {
          let urlFilterSet = null;
          try {
            urlFilterSet = JSON.parse(appHelpers.base64.decode(this.queryString.filterSet));
          } catch (error) {
            urlFilterSet = null;
            let message = this.permaLinkFailMessage;
            if (message && message.length) {
              this.$emit('alert', { text: message, variant: 'danger', countdown: this.countdownSeconds}, firstMessage);
              firstMessage = false;
            }
          }
          if (urlFilterSet) {
            this.setFilter(urlFilterSet);
            let message = this.permaLinkLoadMessage;
            if (message && message.length) {
              this.$emit('alert', { text: message, variant: 'info', countdown: this.countdownSeconds}, firstMessage);
              firstMessage = false;
            }
            return true;
          }
        }
        if (allowTempFlag) {
          filterString = sessionStorage.getItem(filterKey);
        }
        if (filterString) {
          sessionFlag = true;
        } else {
          filterString = localStorage.getItem(filterKey);
          sessionStorage.removeItem(filterKey);
        }
        if (filterString) {
          this.clearFilterSet();
          let filterObj = JSON.parse(filterString);
          Object.assign(this.currentFilters, filterObj);
          this.setFilter(this.currentFilters);
          let message = (sessionFlag ? this.sessionLoadMessage : this.loadMessage);
          if (message && message.length) {
            this.$emit('alert', { text: message, variant: 'info', countdown: this.countdownSeconds}, firstMessage);
            firstMessage = false;
          }
          return true;
        }
        return false;
      },
      calcPermaLink() {
        if (this.filterSetsVisible) {
          let strippedObject = appHelpers.object.strip(this.currentFilters);
          delete strippedObject['pageSize'];
          delete strippedObject['index'];
          this.permaLink = appHelpers.url.getBaseUrl() + `?filterSet=${appHelpers.base64.encode(JSON.stringify(strippedObject))}`;
          return;
        }
        this.permaLink = null;
      }
    }
  };
</script>